import { Component, OnInit, Output, EventEmitter, Input, HostListener, AfterViewInit } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'signals-time-selector-drp-down',
  templateUrl: './time-picker-drop-down.component.html',
  styleUrls: ['./time-picker-drop-down.component.scss']
})
export class TimePickerDropDownComponent implements OnInit, AfterViewInit {
  @Output()
  onTimeChanged: EventEmitter<{ min: string; hr: string }> = new EventEmitter<{ min: string; hr: string }>();

  public value: number;
  public hours = [];
  public minutes = [];
  private readonly onScrollEvent: Subject<{ event: any; elementType: string }> = new Subject<{ event: any; elementType: string }>();

  @Input()
  public selectedTime: { min: string; hr: string } = { min: '00', hr: '00' };
  @Input()
  public timepickerID: string;
  public randomID: string;
  public blockScrollEvent: boolean = true;
  @Input()
  public elementsToShow: number = 6;
  private readonly ELEMENT_HEIGHT: number = 39.4;

  ngOnInit() {
    this.evaluateTimeRange();
    this.generateRandomID();
    if (parseInt(this.selectedTime.min, 10) < this.elementsToShow && parseInt(this.selectedTime.hr, 10) < this.elementsToShow) {
      this.blockScrollEvent = false;
    }

    this.onScrollEvent.pipe(debounceTime(100)).subscribe((data: { event: any; elementType: string }) => {
      if (this.blockScrollEvent) {
        this.blockScrollEvent = false;
        return;
      }
      const topElem = Math.round(data.event.srcElement.scrollTop / this.ELEMENT_HEIGHT);
      const topElemStr = topElem < 10 ? '0' + topElem : topElem;
      const elemReg: any = document.getElementsByClassName(
        `timepicker-${this.randomID}-${this.timepickerID}-${data.elementType}-${topElemStr}`
      );
      this.scrollIntoView(elemReg[0]);
      const newSelected = topElem + 2;
      const newSelectedStr = newSelected < 10 ? '0' + newSelected : '' + newSelected;
      if (data.elementType === 'hour') {
        this.selectedTime.hr = newSelectedStr;
      }
      if (data.elementType === 'minute') {
        this.selectedTime.min = newSelectedStr;
      }
    });
  }

  private scrollIntoView(element) {
    this.blockScrollEvent = true;
    element.parentNode.scrollTop = element.offsetTop;
  }

  ngAfterViewInit() {
    this.focusSelectedTime();
  }

  private evaluateTimeRange() {
    for (let i = 0; i < 60; i++) {
      const toPush: string = (i < 10 ? '0' : '') + i;
      if (i < 24) {
        this.hours.push(toPush);
      }
      this.minutes.push(toPush);
    }
  }

  public timeChanged() {
    this.onTimeChanged.emit(this.selectedTime);
  }

  public changeHour(hour) {
    this.selectedTime.hr = hour;
    this.focusElement(hour, 'hour');
  }

  public changeMinute(minute) {
    this.selectedTime.min = minute;
    this.focusElement(minute, 'minute');
  }

  public focusElement(selected: string, elementType: string) {
    const selectedOnNumber = parseInt(selected, 10);
    let topElem = selectedOnNumber - 2;
    if (topElem < 0) {
      topElem = 0;
    }
    const topElemStr = topElem < 10 ? '0' + topElem : topElem;
    const elemReg: any = document.getElementsByClassName(`timepicker-${this.randomID}-${this.timepickerID}-${elementType}-${topElemStr}`);
    const nextElem = selectedOnNumber + 3;
    const nextElemStr = nextElem < 10 ? '0' + nextElem : nextElem;
    const nextElemRef: any = document.getElementsByClassName(
      `timepicker-${this.randomID}-${this.timepickerID}-${elementType}-${nextElemStr}`
    );
    if (nextElemRef.length) {
      this.scrollIntoView(elemReg[0]);
      return;
    } else {
      const target: any = document.getElementsByClassName(`timepicker-${this.randomID}-${this.timepickerID}-${elementType}`);
      if (target) {
        this.scrollIntoView(target[0].lastElementChild);
      }
      return;
    }
  }

  public focusSelectedTime() {
    this.focusElement(this.selectedTime.hr, 'hour');
    this.focusElement(this.selectedTime.min, 'minute');
  }

  @HostListener('window:scroll', ['$event'])
  scrollHandler(event, elementType) {
    this.onScrollEvent.next({
      event,
      elementType
    });
  }

  private generateRandomID() {
    this.randomID = '_' + Math.random().toString(36).substr(2, 9);
  }
}
